import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { WorkDay } from '@apaq/orgkit-js';
import { isAfter, set, startOfDay } from 'date-fns';

@Component({
  selector: 'ws-work-day-editor',
  templateUrl: './work-day-editor.component.html',
  styleUrls: ['./work-day-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: WorkDayEditorComponent,
      multi: true
    }]
})
export class WorkDayEditorComponent implements ControlValueAccessor {

  constructor() { }

  @Input() title?: string;
  _workDay?: WorkDay;
  disabled = false;
  onChange?: (workDay: WorkDay) => void;

  writeValue(workDay: WorkDay): void {
    this.workDay = workDay;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get hasPeriod() {
    return (this.workDay?.startTime.getTime() ?? 0) < (this.workDay?.endTime.getTime() ?? 0);
  }

  get workDay() {
    return this._workDay!;
  }

  set workDay(value: WorkDay) {
    this._workDay = value;
    if(this.onChange) {
      this.onChange!(this._workDay);
    }

  }

  onCheckedChange(event: Event) {
    if((event as CustomEvent).detail === true) {
      if(!isAfter(this.workDay.endTime, this.workDay.startTime)) {
        this.workDay = {startTime:set(this.workDay.startTime, {hours: 7, minutes: 30}), endTime: set(this.workDay.endTime, {hours: 15, minutes: 0})};
        this.onChange!(this.workDay);
      }
    } else {
      this.workDay = {startTime:startOfDay(this.workDay.startTime), endTime: startOfDay(this.workDay.startTime)};
      this.onChange!(this.workDay);  
    }
  }

}
